import { useTranslation as useI18nextTranslation } from 'react-i18next';
import { I18nextNamespace } from 'app/global/constants/i18n';

export const useTranslation = (namespace?: I18nextNamespace) => {
  return useI18nextTranslation<I18nextNamespace>(namespace);
};
